// --------------------------------------------------------------
// Created On: 2025-04-01
// Author: Hannah Vaughan
//
// Last Modified: 2025-04-02
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";
import styles from "./CommunicationModeControls.module.scss";
import PanelSection from "../PanelSection/PanelSection";

// Container for all communication mode controls provided for the Communication Mode section
// in the Remote Operation Panel.
export default function CommunicationModeControls(props: Props): Component {
  return (
    <PanelSection label="Communication Mode">
      {props.modes.map((mode) => (
        <div className={`col ${styles.controlColumn}`} key={mode.value}>
          <button className="btn btn-primary" type="button" onClick={() => props.onChangeCommunicationMode(mode.value)}>
            {mode.label}
          </button>
        </div>
      ))}
    </PanelSection>
  );
}

CommunicationModeControls.propTypes = {
  modes: PropTypes.array.isRequired,
  onChangeCommunicationMode: PropTypes.func.isRequired,
};

interface Props {
  modes: Mode[];
  onChangeCommunicationMode: (communicationMode: string) => void;
}

interface Mode {
  value: string;
  label: string;
}
